import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0742c0ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { key: 1 }

import { Ref, getCurrentInstance, onBeforeUnmount, onMounted, ref } from "vue";
import PhotoAlbum from "@/components/PhotoAlbum.vue";
import { formatDate } from "@/utils/date";
import type { IPhoto } from "@/types/photo";
import CopyRight from "@/components/CopyRight.vue";
import ToTop from "@/components/ToTop.vue";

const step = 9;
const total = 366;

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const baseUrl = process.env.VUE_APP_BASE_URL;

const instance = getCurrentInstance()?.proxy;

const photoAlbum: Ref<{ getBounds: () => Record<string, number> } | null> = ref(null);
const today = new Date();
let photoAlbumData: Ref<Array<IPhoto>> = ref([]) as Ref<Array<IPhoto>>;
let loadingPhoto = false;
let hiddenCopyRight = false;
let showToTop = false;

function getBounds() {
    const rect = instance?.$el.getBoundingClientRect();
    return {
        width: rect.width,
        height: rect.height,
        top: rect.top,
        left: rect.left,
        right: rect.right,
        bottom: rect.bottom,
    };
}

async function getPhotos() {
    if (loadingPhoto) {
        return;
    }
    loadingPhoto = true;
    const length = photoAlbumData.value.length;
    for (let i = 0; i < step; i++) {
        const date = formatDate(new Date(today.getTime() - 86400000 * (i + length)), "yyyy-MM-dd");
        await fetch(`${baseUrl}/api/cover/${date}`)
            .then((res) => res.json())
            .then((res) => {
                const data = res.data || [];
                data.forEach((item: { url: string; desc: string }) => {
                    photoAlbumData.value.push({
                        src: `${baseUrl}/${item.url}`,
                        alt: date,
                        title: item.desc,
                    });
                });
            })
            .catch((err) => {
                console.error(err);
                photoAlbumData.value.push({
                    src: "",
                    alt: date,
                    title: "加载失败",
                });
            });
    }
    loadingPhoto = false;
}

function handleScroll() {
    hiddenCopyRight = false;
    let photoAlbumRect = photoAlbum.value?.getBounds();
    const instanceRect = getBounds();
    let flag = photoAlbumData.value.length < total;
    if (photoAlbumRect && flag) {
        if (photoAlbumRect.bottom < instanceRect.bottom + 20) {
            // flag = false;
            getPhotos();
        }
    } else if (flag) {
        getPhotos();
    }
    if (window.scrollY > 1000) {
        showToTop = true;
    } else {
        showToTop = false;
    }
}

function toTop() {
    window.scrollTo({ top: 0, behavior: "smooth" });
}

onMounted(() => {
    getPhotos().then(() => {
        handleScroll();
    });
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleScroll);
});

onBeforeUnmount(() => {
    window.removeEventListener("scroll", handleScroll);
    window.removeEventListener("resize", handleScroll);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(photoAlbumData).length)
      ? (_openBlock(), _createBlock(PhotoAlbum, {
          key: 0,
          ref_key: "photoAlbum",
          ref: photoAlbum,
          data: _unref(photoAlbumData)
        }, null, 8, ["data"]))
      : (_openBlock(), _createElementBlock("p", _hoisted_2, "正在加载...")),
    _createVNode(CopyRight, {
      class: _normalizeClass({ hidden: _unref(hiddenCopyRight) })
    }, null, 8, ["class"]),
    _createVNode(ToTop, {
      onToTop: toTop,
      show: _unref(showToTop)
    }, null, 8, ["show"])
  ]))
}
}

})